import React from 'react';
import ResourcesCategory from './resourcesCategory';

var ResourcesList = function ResourcesList(_ref) {
  var categoryId = _ref.categoryId,
      subCategories = _ref.subCategories,
      toggleVideoModal = _ref.toggleVideoModal,
      loggedNotConsumer = _ref.loggedNotConsumer,
      subcategoryVideoTutorials = _ref.subcategoryVideoTutorials;
  var content = subCategories === null || subCategories === void 0 ? void 0 : subCategories.map(function (item, index) {
    return (item === null || item === void 0 ? void 0 : item.name) === subcategoryVideoTutorials ? loggedNotConsumer ? React.createElement(ResourcesCategory, {
      subCategory: item,
      key: index,
      categoryId: categoryId,
      showDownloadAll: categoryId !== 9999
    }) : null : React.createElement(ResourcesCategory, {
      subCategory: item,
      key: index,
      categoryId: categoryId,
      showDownloadAll: categoryId !== 9999
    });
  });
  return React.createElement("div", {
    className: "col-span-12 md_pb-36 pb-12 sm_col-span-9 pt-0 md_pt-14 bg-white"
  }, content);
};

export default ResourcesList;